import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, formatDate, getCurrentDateTime, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { SelectDoctorTable } from '../masters/others/SelectDoctorTable';
import { DOCTOR_SHIFT_DROPDOWN } from '../../../../../constants/dropdown';

const TABLE_HEADER = [
  {
    header: ' Date',
    accessor: (row) => formatDate(row?.date)
  },
  {
    header: 'Doctor',
    accessor: (row)=> row?.doctor?.name
  },
  {
    header: 'Department',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.department?.department}`}
        </span>
      );
    }
  },
  {
    header: 'Sponsor',
    accessor: (row)=> row?.sponsor?.name
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const WARD_WISE_CONSULTANT_VISIT_CHARGES_TABLE = [
  {
    header: 'Ward Name',
    accessor: (row)=> row?.name || row?.ward_name
  },
  {
    header: 'Charges',
    accessor: ''
  },
  {
    header: 'Quantity',
    accessor: ''
  }
];

const initialConsultantVisitChargesDataObj = {
  data: [],
  loading: false
};

export const WardWiseConsultantVisitCharges = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [opdBillingDataObj, setOpdBillingDataObj] = useState(initialConsultantVisitChargesDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const [sponsorDropdown, setSponsorDropdown] = useState([]);
  const [visitTypeDropdown, setVisitTypeDropdown] = useState([]);
  const [wardDrodpdown, setWardDropdown] = useState([]);
  const [input, setInput] = useState('');
  const [originalData, setOriginalData] = useState([]);
  const [selectedRows,setSelectedRows] = useState([]);
  const [inputValue, setInputValue] = useState([]);


  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
      
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: getCurrentDateTime('time'),
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue ,getValues} = methods;

  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('department');
    setDepartmentDropdown(data);
  }, []);

  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    if (!selectedRecord && !getValues('consultant')) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('consultant', defaultState?._id);
      if (defaultState) {
        setValue('department', defaultState.qualification_details.department);
      }
    }
    setDoctorDropdown(data);
  }, [selectedRecord, getValues, setValue]);

  const getSponsorDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    setSponsorDropdown(data);
  });

  const getVisitTypeDropdown = useCallback(async () => {
    const data = await dropdownFetch('visit-type-master');
    setVisitTypeDropdown(data);
  });

  const getWardDropdown = useCallback(async () => {
    const data = await dropdownFetch('ward');
    setWardDropdown(data);
  });

  useEffect(
    () => {
      getDepartmentDropdown();
      getDoctorDropdown();
      getSponsorDropdown();
      getVisitTypeDropdown();
      getWardDropdown();
    },
    getDepartmentDropdown,
    getDoctorDropdown,
    getSponsorDropdown,
    getVisitTypeDropdown,
    getWardDropdown
  );

 useEffect(()=>{
    if(selectedRecord){
        setValue('consultant', selectedRecord.doctor?._id)
        setValue('sponsor',selectedRecord.sponsor?._id)
        setValue('department',selectedRecord.department?._id)
        setValue('visit_type',selectedRecord?.visit_type)
        setValue('doctor_shift',selectedRecord?.doctor_shift)
        setWardDropdown(selectedRecord?.ward_charges)
    }
 },[selectedRecord])



const formSubmit = async (formValues) => {
  setLoading(true);
  const editFlag = selectedRecord && currentAction === 'edit';
  const updatedDetailList = selectedRows.map((item) => {
    const productId = item._id;
    const Charges = inputValue[productId]?.Charges ?? null;
    const Quantity = inputValue[productId]?.Quantity ?? null;
    return {
      ...item,
      ward: productId,
      charge: Charges,
      quantity: Quantity,
    };
  }).filter(Boolean);
  try {
    const response = await request(
      editFlag ? '/ward-wise-consultant-visit-charges-update' : '/ward-wise-consultant-visit-charges-create',
      {
        method: editFlag ? 'PUT' : 'POST',
        params: editFlag ? selectedRecord._id : undefined,
        body: {
          ...formValues,
          ward_charges: updatedDetailList,
        },
      }
    );

    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Ward Wise Consultant Visit Charges`, {
        variant: 'success',
      });
      setSelectedRecord(response.data);
      setCurrentAction(); 
      reset(); 
    } else {
      toast(`${response.message || `Failed to ${editFlag ? 'update' : 'create'} Ward Wise Consultant Visit Charges`}`, {
        variant: 'error',
      });
    }
  } catch (error) {
    toast(`An unexpected error occurred`, { variant: 'error' });
    console.error('Form submit error:', error);
  } finally {
    setLoading(false);
  }
};


  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/opd-requisition-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel OPD Requisition', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel OPD Requisition', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setOpdBillingDataObj({ loading: true });
    const response = await request('/ward-wise-consultant-visit-charges-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setOpdBillingDataObj({ loading: false, data: filteredData });
      setOriginalData(filteredData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setOpdBillingDataObj({ loading: false });
    }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  const isSelected = (row, field) => {
    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      return false;
    }
    const selectedRow = selectedRows?.find((selectedRow) => selectedRow?._id === row?._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }
    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      setSelectedRows([]);
      return;
    }
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows?.find((selectedRow) => selectedRow?._id === row?._id);
      if (existingRow) {
        if (existingRow[field]) {
          return prevSelectedRows?.filter((selectedRow) => selectedRow?._id !== row?._id);
        } else {
          return prevSelectedRows.map((selectedRow) =>
            selectedRow?._id === row?._id ? { ...selectedRow, [field]: true } : selectedRow
          );
        }
      } else {
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };

    const handleInputChange = (id, Charges, value) => {
    setInputValue((prevInputValues) => ({
      ...prevInputValues,
      [id]: {
        ...prevInputValues[id],
        [Charges]: value
      }
    }));
  };



useEffect(() => {
  if (Array.isArray(wardDrodpdown)) {
    const inputValuesMap = {};
    wardDrodpdown.forEach((item) => {
      const rowId = item?._id || item?.ward; 
      inputValuesMap[rowId] = {
        Charges: item.charge || '',
        Quantity :item.quantity || "",
      };
    });
    setInputValue(inputValuesMap);
  } else {
    setInputValue({});
  }
}, [wardDrodpdown]);


  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{ pb: 0.5, mb: 3, borderBottom: '1px solid', borderColor: 'grey.300' }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Ward Wise Consultant Visit Charges
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>

            <Grid container spacing={2}>
              <Grid item xs={6} sx={{ display: 'flex', gap: 0.7, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Consultant
                  </Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="consultant"
                    placeholder="Select Consultant"
                    menus={doctorDropdown.map((data) => ({ ...data, name: data.name }))}
                    onChange={({ target: { row } }) => {
                      setValue('department', row.qualification_details.department);
                    }}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Sponsor
                  </Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="sponsor"
                    placeholder="Select Sponsor"
                    menus={sponsorDropdown.map((data) => ({ ...data, name: data.name }))}
                  />
                </Stack>
              </Grid>
              <Grid item xs={6} sx={{ display: 'flex', gap: 0.7, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Department</Typography>
                  <SelectTag
                    disabled
                    formControlSX={{ flex: 0.8 }}
                    name="department"
                    placeholder="Select Department"
                    menus={departmentDropdown.map((data) => ({ ...data, name: data.department }))}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Visit Type</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="visit_type"
                    placeholder="Select Visit type"
                    menus={visitTypeDropdown.map((data) => ({ ...data, name: data.VISIT_TYPE }))}
                  />
                </Stack>
              </Grid>
                <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doctor Shift</Typography>
                  <SelectTag
                    disabled={!['new','edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="doctor_shift"
                    placeholder="Select Department"
                    menus={DOCTOR_SHIFT_DROPDOWN}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', minHeight: '48rem' }}>
                <SelectDoctorTable
                  containerSX={{ p: 1, flex: 1, border: '1px solid rgba(0,0,0,0.27)', minHeight: '48rem' }}
                  data={['new','edit'].includes(currentAction) && wardDrodpdown?.map((data) => ({ ...data, _id: data?._id || data?.ward})) || []}
                  columns={WARD_WISE_CONSULTANT_VISIT_CHARGES_TABLE}
                  size="small"
                  showInputFields={true}
                  showOk={true}
                  isSelected={isSelected}
                  handleRowSelect={handleRowSelect}
                  currentAction={'new'}
                  selectedRows={selectedRows}
                  handleInputChange={handleInputChange}
                  inputValues={inputValue}
                />
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Ward Wise Consultant Visit Charges
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem'
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={originalData || []}
          loading={opdBillingDataObj.loading}
          onRowClick={(row) => {
            delete row.patient;
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
